import { object, string, date } from "yup";

const taskSchema = (localization) => object({
  content: string().required(localization .fields.content.errors.required),
  target_date: date()
    .required(localization  .fields.target_date.errors.required)
    .test(
      "is-target-date-valid",
      localization  .fields.target_date.errors.is_target_date_valid,
      (target_date, context) => {
        const { start_date, end_date } = context.options.context || {};
        
        if (target_date && start_date && end_date) {
          return target_date >= start_date && target_date <= end_date;
        }

        return false;
      }
    ),
}).required();

export default taskSchema;